"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsultationModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const appointment_entity_1 = require("./appointment.entity");
const consultation_service_1 = require("./consultation.service");
const consultation_controller_1 = require("./consultation.controller");
const notifications_module_1 = require("../notifications/notifications.module");
const order_entity_1 = require("../orders/order.entity");
const order_line_item_entity_1 = require("../orders/order-line-item.entity");
const user_entity_1 = require("../users/user.entity");
const customer_entity_1 = require("../customers/customer.entity");
let ConsultationModule = class ConsultationModule {
};
exports.ConsultationModule = ConsultationModule;
exports.ConsultationModule = ConsultationModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([appointment_entity_1.Appointment, order_entity_1.Order, order_line_item_entity_1.OrderLineItem, user_entity_1.User, customer_entity_1.Customer]), notifications_module_1.NotificationsModule],
        providers: [consultation_service_1.ConsultationService],
        controllers: [consultation_controller_1.ConsultationController],
        exports: [consultation_service_1.ConsultationService],
    })
], ConsultationModule);
